/**
 * Centralized Configuration for MVG Inventory Management
 * This file is the single source of truth for all environment-related settings.
 * It uses module.exports to be compatible with setupProxy.js (CommonJS) 
 * and standard React components (ESModules).
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const getIsLocalhost = () => {
    if (typeof window === 'undefined') return true;
    const hostname = window.location.hostname;
    return hostname === 'localhost' || 
           hostname === '127.0.0.1' || 
           hostname.startsWith('10.') || 
           hostname.startsWith('192.168.') || 
           hostname.startsWith('172.');
};

const isLocalhost = getIsLocalhost();

// Tự động quét và lấy IP LAN của card mạng khi chạy trong môi trường Node.js (Vite/Webpack Dev Server)
const getLocalIpAddress = () => {
    if (typeof window !== 'undefined') return window.location.hostname;
    try {
        const req = typeof require !== 'undefined' ? eval('require') : null;
        if (!req) return 'localhost';
        const os = req('os');
        const interfaces = os.networkInterfaces();
        for (const devName in interfaces) {
            const iface = interfaces[devName];
            for (let i = 0; i < iface.length; i++) {
                const alias = iface[i];
                if (alias.family === 'IPv4' && !alias.internal) {
                    return alias.address;
                }
            }
        }
    } catch (e) {
        console.warn('Failed to detect local IP, falling back:', e);
    }
    return 'localhost';
};

// 1. Local Development URL (Your machine)
const LOCAL_API_URL = typeof window !== 'undefined' 
    ? `http://${window.location.hostname}:5237` 
    : `http://${getLocalIpAddress()}:5237`;


// 2. Production VPS URL (When deploying with Docker)
const VPS_API_URL = 'https://qlkho.minhvietgroup.vn';

/**
 * Automatically detects the base URL based on environment variables or hostname.
 */
const getBaseUrl = () => {
    // Priority 1: Environment variable (Passed from Dockerfile/CI)
    if (process.env.REACT_APP_API_URL) {
        const envUrl = process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');
        // LỰC CHIẾN: Nếu đang truy cập qua IP LAN nhưng env là localhost, bỏ qua env để dùng IP động
        if (typeof window !== 'undefined' && 
            window.location.hostname !== 'localhost' && 
            window.location.hostname !== '127.0.0.1' && 
            envUrl.includes('localhost')) {
            // Bỏ qua env localhost ở client LAN
        } else {
            return envUrl;
        }
    }
    
    // Priority 2: Forced VPS mode for testing production APIs locally
    const FORCE_VPS = false; 
    if (FORCE_VPS) return VPS_API_URL;

    // Priority 3: Automatic detection
    let detectedUrl = isLocalhost ? LOCAL_API_URL : VPS_API_URL;

    // LỰC CHIẾN: Nếu đang chạy trên domain thật, bắt buộc dùng HTTPS
    if (typeof window !== 'undefined' && window.location.hostname === 'qlkho.minhvietgroup.vn') {
        detectedUrl = 'https://qlkho.minhvietgroup.vn';
    }

    return detectedUrl;
};

const BASE_URL = getBaseUrl();
const API_URL = `${BASE_URL}/api`;

const config = {
    // URLs
    BASE_URL: BASE_URL,             // e.g., http://localhost:5236
    API_URL: API_URL,               // e.g., http://localhost:5236/api
    BACKEND_ROOT_URL: BASE_URL,     // Legacy support
    API_BASE_URL: API_URL,          // Legacy support
    SIGNALR_HUB_URL: `${BASE_URL}/notificationHub`,
    
    // Settings
    TIMEOUT: 15000,
    IS_DEVELOPMENT: isDevelopment,
    IS_LOCALHOST: isLocalhost,
};

// Also export individual constants for easy importing
config.API_BASE_URL = API_URL;
config.SIGNALR_HUB_URL = `${BASE_URL}/notificationHub`;

module.exports = config;
